export var sum = function(values) {
    return values.reduce(function(acc, value) {
        return acc + value;
    }, 0);
};
